export interface IUpdateProductCategoriesDto {
    categoriesToAdd: string[];
    categoriesToRemove: string[];
    newCategory: string | null;
}

export class UpdateProductCategoriesDto implements IUpdateProductCategoriesDto {
    public categoriesToAdd: string[];
    public categoriesToRemove: string[];
    public newCategory: string | null;

    constructor(categoriesToAdd: string[], categoriesToRemove: string[], newCategory: string | null){
        this.categoriesToAdd = categoriesToAdd;
        this.categoriesToRemove = categoriesToRemove;
        this.newCategory = newCategory;
    }
}